// app/javascript/projects/components/ModalDivider.jsx
import React from 'react';

function ModalDivider(props) {
  return (<div style={{borderBottom:"1px solid lightGray"}}></div>)
}
export default ModalDivider;
